/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_MilestoneInputs */

const en_prop_milestone = /** @type {(inputs: Prop_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone`)
};

const de_prop_milestone = /** @type {(inputs: Prop_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein`)
};

/**
* | output |
* | --- |
* | "Milestone" |
*
* @param {Prop_MilestoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_milestone = /** @type {((inputs?: Prop_MilestoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_MilestoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_milestone(inputs)
	return en_prop_milestone(inputs)
});